import React, { Component } from 'react'
import CSSModules from 'react-css-modules'
import {
  ContainerDivs
} from '../'
import Styles from './OneTwoThree.css'

@CSSModules(Styles, {allowMultiple: true})
export default class OneTwoThree extends Component {
  render() {
    const icon1 = require( '../../../static/images/123-1.png' )
    const icon2 = require( '../../../static/images/123-2.png' )
    const icon3 = require( '../../../static/images/123-3.png' )

    //
    return (
      <div styleName='_123-wrap'>
        <ContainerDivs>
          <h2>
            How retirement funds impact society
          </h2>
          <div styleName='_123-flex'>
            <div styleName='_123-cell'>
              <div styleName='_123-image'>
                <img
                  src={icon1}
                  alt='Step 1'
                />
              </div>
              <h3 styleName='_123-copy'>
                Companies like <b>Amazon</b> and <b>Comcast</b> offer
                employees a corporate retirement plan, to help them save for
                the future.
              </h3>
            </div>
            <div styleName='_123-cell'>
              <div styleName='_123-image'>
                <img
                  src={icon2}
                  alt='Step 2'
                />
              </div>
              <h3 styleName='_123-copy'>
                Asset managers like <b>Vanguard</b> and <b>BlackRock</b> take
                that money and invest it in the stock market via mutual funds.
              </h3>
            </div>
            <div styleName='_123-cell'>
              <div styleName='_123-image'>
                <img
                  src={icon3}
                  alt='Step 3'
                />
              </div>
              <h3 styleName='_123-copy'>
                The money is invested in fossil fuel companies
                like <b>ExxonMobil</b>, arms manufacturers
                like <b>Raytheon</b>, and private prison operators
                like <b>CoreCivic</b>.
              </h3>
            </div>
          </div>
        </ContainerDivs>
      </div>
    )
  }
}